import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import FeaturetteStyles from './Featurette.styled';

const Featurette = ({
  primary,
  secondary,
  reverseOnMobile = false,
  center = false,
  padding = false,
  isAnimated = true,
  modal = null,
  dropShadow = true,
  ...props
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.5 });

  return (
    <FeaturetteStyles
      {...props}
      reverseOnMobile={reverseOnMobile}
      center={center}
      padding={padding}
      ref={ref}
      dropShadow={dropShadow}
      className={`block-featurette ${isAnimated ? 'isAnimated' : ''} ${
        inView ? 'active' : ''
      }`}
    >
      <div className='inner'>
        <div className='column'>{primary}</div>
        <div className='column'>{secondary}</div>
      </div>
      {modal && <div className='modal'>{modal}</div>}
    </FeaturetteStyles>
  );
};

Featurette.propTypes = {
  primary: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  secondary: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  reverseOnMobile: PropTypes.bool,
  center: PropTypes.bool,
  padding: PropTypes.bool,
  isAnimated: PropTypes.bool,
};

export default Featurette;
